import React from "react";
import { useState } from "react"
import BonusGiftIcon from "../Icons/BonusGiftIcon";
import BonusGiftHoverIcon from "../Icons/BonusGiftHoverIcon";
import {submitV2AnalyticsEvent} from "../../../analytics/analyticsUtils";

const BonusGift = ({domainCountry}) => {
  const [iconToShow, setIconToShow] = useState("bonusGift")
  const showIcon = (iconName) => () => {
    setIconToShow(iconName)
  }

  const moveToHotWaterPage = () => () => {
    submitV2AnalyticsEvent("clickPromoBadge", {
      promotion: "Bonus Gift",
      origin: "PDP"
    });
    let domain = "com.au";
    if (domainCountry === "NZ") {
      domain = "co.nz";
    }

    const url = `https://www.reece.${domain}/hot-water-season`;
    window.open(url, "_blank");
  }

  return (
    <>
      {iconToShow === "bonusGift" ? <BonusGiftIcon onHoverStart={showIcon("bonusGiftHover")} /> : null}
      {iconToShow === "bonusGiftHover" ? (<BonusGiftHoverIcon onClick={moveToHotWaterPage()} onHoverEnd={showIcon("bonusGift")} />) : null}
    </>
  );
}

export default BonusGift;